export { TrustpilotWidget } from './TrustpilotWidget';
export { isTrustpilotEnabledLocale } from './locales';
